<template>
  <div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
      <el-form-item label="New password" prop="password"
      :rules="{required: true,validator: handlePasswordLevel, trigger: 'change' }">
        <el-popover ref="popover" placement="right" width="200" trigger="focus">
          <div :style="'color:' + levelColor[levelStatus]">
            <i :class="levelClass[levelStatus]"></i>
            {{ levelNames[levelStatus] }}
          </div>
          <div style="display: flex;margin-top: 10px;">
            <el-progress
              style="width: 33%;"
              v-for="(item, id) in levelNames"
              :key="id"
              v-if="id > 0"
              :percentage="id > levelStatus ? 0 : (id < levelStatus?100:levelPercent)"
              :show-text="false"
              :color="levelColor[levelStatus]"
            ></el-progress>
          </div>
        </el-popover>
        <el-input v-popover:popover type="password" v-model="ruleForm.password" placeholder="Password"></el-input>
      </el-form-item>


      <el-form-item
        label="Confirm password"
        prop="confirmPassword"
        :rules="{
          required: true,
          message: 'Please enter the confirm Password!',
          trigger: 'blur'
        }"
      >
        <el-input type="password" v-model="ruleForm.confirmPassword"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="flex">
        <el-button @click="prevStepHandle">Previous</el-button>
        <el-button :loading="loading" type="primary" class="btn" @click="nextStepHandle('ruleForm')">Submit</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { putAction, getAction } from '@/api/manage.js';
export default {
  name: 'Step3',
  //    components: {
  //      Result
  //    },
  props: {
    userInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    prevStep:{
      type: Function
    },
    nextStep: {
      type: Function
    }
  },
  data() {
    return {
      levelNames: ['low', 'low', 'Medium', 'Strong'],
      levelClass: ['el-icon-error', 'el-icon-error', 'el-icon-warning', 'el-icon-success'],
      levelColor: ['#ff0000', '#ff0000', '#ff7e05', '#52c41a'],
      levelStatus: 0,
      levelPercent: 10,
      ruleForm: {
        password: '',
        confirmPassword: ''
      },
      loading: false
    };
  },
  methods: {
    //密码强度校验
    handlePasswordLevel(rule, value, callback) {

      let level = 0
      let reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/;
      if(value==''){
        callback(new Error('Please enter the Password'))
      }
      if (!reg.test(value)) {
        callback(new Error('Password must contain letters, 8 numbers and special characters.'))
      }
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.levelStatus = level
      this.levelPercent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.levelPercent = 100
        }
        callback()
      } else {
        if (level === 0) {
          this.levelPercent = 10
        }
        callback(new Error('The password strength is not enough'))
      }

    },

    nextStepHandle(type) {
      let that = this;
      that.loading = true;
      if(that.ruleForm.password!=that.ruleForm.confirmPassword){
        this.$message('Inconsistent passwords')
        return;
      }
      var userList = {...that.userInfo,...{
        password:that.ruleForm.password
      }};

      this.$refs[type].validate(valid => {
        if (valid) {
          var params = {
            email:that.userInfo.email,
            password:that.ruleForm.password,
            verifyCode:that.userInfo.verifyCode
          };

          getAction('/sys/user/passwordChange', params).then(res => {
            if (res.success) {

              console.log(userList);
              that.$emit('nextStep', userList);
            } else {

              that.loading = false;
            }
          });
        } else {
          that.loading = false;
        }
      });
    },
    prevStepHandle() {
      this.$emit('prevStep', this.userInfo);
    }

  }
};
</script>
<style lang="less" scoped>
.stepFormText {
  margin-bottom: 24px;
}
.flex{
  display: flex;
  width: 60%;
}
.btn{
  display: block;
  color: #262613;
  background: #F3E93D;
  border-color: #E1E1E1;
}
.ant-form-item-label,
.ant-form-item-control {
  line-height: 22px;
}
@media screen and (max-width: 420px) {
  /deep/ .ant-col.ant-col-9.ant-form-item-label {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/forget/Step3.vue